import script from "./TaskViewerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskViewerModal.vue?vue&type=script&setup=true&lang=js"

import "./TaskViewerModal.vue?vue&type=style&index=0&id=1194a282&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1194a282"]])

export default __exports__